export { default as usePublicationSettings } from './usePublicationSettings';
export const GLOBAL_PUBLICATION_KEY = 'global';
